import { Card, Col, Row } from 'antd';
import React from 'react';
import logoImg from '../../images/logo.jpg';
import './style.css';

const Home = () => {
  return (
    <div className='home'>
      <Card>
        <header>
          <div className='img'>
            <img src={logoImg} alt='' />
          </div>
          <div className='text'>
            <div className='title'>你好，管理员</div>
            <div className='desc'>最近登录：2020-04-05 12：31：37</div>
          </div>
        </header>
      </Card>

      <Card title='消息中心' style={{ marginTop: '20px' }} className='messages'>
        <section>
          <Row gutter={24}>
            <Col span={8}>
              <Card title='待办消息' extra={<a href='#'>2</a>}>
                <ul>
                  <li>
                    <span>有 1 条付款被驳回</span>
                    <span className='details'>
                      <a href=''>查看详情</a>
                    </span>
                  </li>
                  <li>
                    <span>有 3 条消息待审批</span>
                    <span className='details'>
                      <a href=''>查看详情</a>
                    </span>
                  </li>
                </ul>
              </Card>
            </Col>
            <Col span={8}>
              <Card title='消息通知' extra={<a href='#'>1</a>}>
                <ul>
                  <li>
                    <span>您有 1 项应付账款结算已完成</span>
                    <span className='details'>
                      <a href=''>查看详情</a>
                    </span>
                  </li>
                </ul>
              </Card>
            </Col>
            <Col span={8}>
              <Card title='系统通知' />
            </Col>
          </Row>
        </section>
      </Card>
    </div>
  );
};

export default Home;
